export const formatCommuteTimeForDisplay = (time: number): string => {
  if (time < 60) return `${time} mins`;
  if (time === 60) return '1 hour';

  const hours = Math.floor(time / 60);
  const minutes = time % 60;

  if (minutes === 0) {
    return `${hours} hours`;
  }
  return `${hours} hr ${minutes} mins`;
};
